import { useState } from "react";
import { useApp, useData } from "../lib/app";
import TaskCard from "../components/TaskCard";
import { AiLoader, Empty, ErrorCard, Header, PersonChip } from "../components/bits";
import { useT } from "../lib/i18n";

const TABS = [["today", "Today"], ["upcoming", "Upcoming"], ["done", "Done"]];
const EMPTY = { today: ["🌸", "Nothing on your mind right now. Lovely. 🌸"], upcoming: ["🌿", "Nothing coming up yet."], done: ["✨", "Done tasks will show here."] };

export default function Tasks() {
  const { me } = useApp();
  const t = useT();
  const [tab, setTab] = useState("today");
  const [person, setPerson] = useState(null);
  const { data, isLoading, error, refetch } = useData(`/tasks?tab=${tab}${person ? `&person=${person}` : ""}`, { refetchInterval: 30000 });
  return (
    <div>
      <Header title={me.admin ? "All tasks" : "My tasks"} kicker={me.admin ? "Everyone's share, in one place" : t("Hi {name}", { name: me.me.name })} />
      <div className="flex bg-[#F1EEFB] rounded-2xl p-1 mb-3">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`tasks-tab-${k}`} onClick={() => setTab(k)}
            className={`flex-1 min-h-[44px] rounded-xl font-extrabold text-sm transition-colors ${tab === k ? "bg-white text-[#6A5AE0] shadow" : "text-[#6B6680]"}`}>{t(l)}</button>
        ))}
      </div>
      {!me.admin && (
        <div className="flex gap-2 pb-2 mb-1">
          <button data-testid="tasks-filter-mine" className="ul-chip" data-on={!person} onClick={() => setPerson(null)}>{t("Mine")}</button>
          <button data-testid="tasks-filter-given" className="ul-chip" data-on={person === "given"} onClick={() => setPerson("given")}>{t("I gave to others")}</button>
        </div>
      )}
      {me.admin && (
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2 mb-1">
          <button data-testid="tasks-filter-all" className="ul-chip" data-on={!person} onClick={() => setPerson(null)}>{t("Everyone")}</button>
          <button data-testid="tasks-filter-given" className="ul-chip" data-on={person === "given"} onClick={() => setPerson("given")}>{t("I gave to others")}</button>
          {me.members.filter((m) => m.type !== "child" && m.status !== "pending").map((m) => (
            <span key={m.id} className={`rounded-full ${person === m.id ? "ring-2 ring-[#6A5AE0]" : ""}`}><PersonChip m={m} onClick={() => setPerson(m.id)} testid={`tasks-filter-${m.name.toLowerCase()}`} /></span>
          ))}
        </div>
      )}
      {isLoading ? <AiLoader /> : error ? <ErrorCard onRetry={refetch} /> : data.length === 0 ? <Empty emoji={EMPTY[tab][0]} text={person === "given" ? "Tasks you give to others show here." : EMPTY[tab][1]} /> : (
        <div className="space-y-3" data-testid="tasks-list">{data.map((tk) => <TaskCard key={tk.id} t={tk} />)}</div>
      )}
    </div>
  );
}
